/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ seats: NonNullable<unknown>, price: NonNullable<unknown> }} Cost_Calc_Copilot_LineInputs */



/**
* | output |
* | --- |
* | "Copilot: {seats} × €{price}" |
*
* @param {Cost_Calc_Copilot_LineInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cost_calc_copilot_line = /** @type {((inputs: Cost_Calc_Copilot_LineInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cost_Calc_Copilot_LineInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Copilot: ${i?.seats} × €${i?.price}`)
	return /** @type {LocalizedString} */ (`Copilot: ${i?.seats} × €${i?.price}`)
});